import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import settings from './settings'
import flights from './flights'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    settings, flights
  },
  plugins: [vuexLocal.plugin]
})
